// src/components/DocsBreadcrumbs.jsx
import { Breadcrumbs, Link, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import commandList from 'data/commands';

const pathLabelMap = {
  home: '홈',
  docs: '명령어',
  game: '미니게임',
  overwatch: '오버워치',
  tarkov: '타르코프',
  meal: '급식',
  etc: '기타',
  custom: '커스텀 봇'
};

const DocsBreadcrumbs = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  // 마지막 path에 해당하는 명령어를 찾음
  const lastFullPath = '/' + pathnames.join('/');
  const command = commandList.find((cmd) => cmd.path === lastFullPath);
  const lastLabel = command?.name || pathnames[pathnames.length - 1];

  return (
    <Breadcrumbs sx={{ mt: {xs:0, sm:0, md:-6}, mb: {xs:5, sm:4, md:4},ml: {xs:0, sm:1, md:0} }} separator="›" aria-label="breadcrumb">
      <Link color="inherit" href="/">홈</Link>
      {pathnames.map((value, index) => {
        const isLast = index === pathnames.length - 1;
        const label = isLast
          ? lastLabel
          : pathLabelMap[value] || value;
        const to = '/' + pathnames.slice(0, index + 1).join('/');

        return isLast ? (
          <Typography key={to} color="text.primary">
            {label}
          </Typography>
        ) : (
          <Link key={to} color="inherit" href={to}>
            {label}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};

export default DocsBreadcrumbs;
